import _classCallCheck from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paragraph/insertparagraphcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
/**
 * The insert paragraph command. It inserts a new paragraph at a specific
 * {@link module:engine/model/position~Position document position}.
 *
 *		// Insert a new paragraph before an element in the document.
 *		editor.execute( 'insertParagraph', {
 *			position: editor.model.createPositionBefore( element )
 *		} );
 *
 * If a paragraph is disallowed in the context of the specific position, the command
 * will attempt to split position ancestors to find a place where it is possible
 * to insert a paragraph.
 *
 * **Note**: This command moves the selection to the inserted paragraph.
 *
 * @extends module:core/command~Command
 */

var InsertParagraphCommand = /*#__PURE__*/function (_Command) {
  _inherits(InsertParagraphCommand, _Command);

  var _super = _createSuper(InsertParagraphCommand);

  function InsertParagraphCommand() {
    _classCallCheck(this, InsertParagraphCommand);

    return _super.apply(this, arguments);
  }

  _createClass(InsertParagraphCommand, [{
    key: "execute",
    value:
    /**
     * Executes the command.
     *
     * @param {Object} options Options for the executed command.
     * @param {module:engine/model/position~Position} options.position The model position at which
     * the new paragraph will be inserted.
     * @fires execute
     */
    function execute(options) {
      var model = this.editor.model;
      var position = options.position;
      model.change(function (writer) {
        var paragraph = writer.createElement('paragraph');

        if (!model.schema.checkChild(position.parent, paragraph)) {
          var allowedParent = model.schema.findAllowedParent(position, paragraph); // It could be there's no ancestor limit that would allow paragraph.
          // In theory, "paragraph" could be disallowed even in the "$root".

          if (!allowedParent) {
            return;
          }

          position = writer.split(position, allowedParent).position;
        }

        model.insertContent(paragraph, position);
        writer.setSelection(paragraph, 'in');
      });
    }
  }]);

  return InsertParagraphCommand;
}(Command);

export { InsertParagraphCommand as default };